module.exports = __webpack_public_path__ + "static/media/bd1.35d8cfea.jpg";